import { API } from "@/app/api";
import {
  IUserData,
  IUserEnumerateAll,
} from "@/data/api/auth-data";
import {
  getResponseStatus,
  normalizeErrorStatus,
  postApi,
} from "./post-api";

export async function fetchUserCredentials(
  sessionId: string | undefined,
  successCallback: (userData: IUserData) => void,
  errorCallback: (status: string) => void
) {
  if (sessionId == undefined) return;

  // fetch(API.User.Credentials, {
  //   method: "POST",
  //   body: JSON.stringify({ id: sessionId }),
  // })
  await postApi<IUserData>(API.User.Credentials, { id: sessionId })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback(response);
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

export async function fetchUserIsAdmin(
  sessionId: string | undefined,
  coin: string | undefined = undefined,
  successCallback: (isAdmin: boolean) => void,
  errorCallback: (status: string) => void
) {
  if (sessionId == undefined) return;

  // fetch(API.User.AllUsers, {
  //   method: "POST",
  //   body: JSON.stringify({
  //     id: sessionId,
  //     size: 10,
  //     sortBy: "averagePower",
  //     coin: coin,
  //   }),
  // })
  await postApi<IUserEnumerateAll>(API.User.AllUsers, {
    id: sessionId,
    size: 10,
    sortBy: "averagePower",
    coin: coin,
  })
    .then((response) => {
      if (response && response.status == API.Status.Success) {
        successCallback(
          (response.users?.length != undefined && response.users?.length > 0) ??
            false
        );
      } else {
        errorCallback(getResponseStatus(response));
      }
    })
    .catch((reason) => {
      errorCallback(normalizeErrorStatus(reason));
    });
}

// export async function fetchUserPayoutSettings(
//   sessionId: string | undefined,
//   successCallback: (userSettingsCoins: IUserSettingsCoin[] | undefined) => void,
//   errorCallback: (status: string) => void
// ) {
//   if (sessionId == undefined) return;

//   await axiosInstance
//     .post(API.User.Settings, JSON.stringify({ id: sessionId }))
//     .then((res) => res.data)
//     .then((data) => {
//       const response: IUserSettings = JSON.parse(JSON.stringify(data));

//       if (response && response.status == API.Status.Success) {
//         successCallback(response.coins);
//       } else {
//         if (response && response.status) errorCallback(response.status);
//         else errorCallback(API.Status.Unknown);
//       }
//     })
//     .catch((reason) => {
//       errorCallback(reason);
//     });
// }
